export const PER_PAGE = 10;